import React, { Fragment, useState } from "react";
import { CaretDownIcon, DotsThreeIcon, PencilIcon, TrashIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import AgentsPopupRemove from "components/Agents/AgentsPopupRemove";

export default function SidebarAgentItem({
    agent,
    childAgents = []
}) {

    const [openDropdown, setOpenDropdown] = useState(false);
    const [removePopup, setRemovePopup] = useState(false);
    const [accordionOpen, setAccordionOpen] = useState(false);

    const hasChildren = childAgents.length > 0;

    const removePopupHandler = () => {
        setOpenDropdown(false);
        return setRemovePopup(true);
    }

    return (
        <Fragment>
            <div
                className="group flex gap-2 items-center w-full p-2 hover:bg-light/30 rounded-sm"
                onMouseLeave={() => setOpenDropdown(false)}
                onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setOpenDropdown(false); }}
            >
                {hasChildren && (
                    <button
                        type="button"
                        aria-label={accordionOpen ? 'Comprimi sotto-agenti' : 'Espandi sotto-agenti'}
                        aria-expanded={accordionOpen}
                        onClick={() => setAccordionOpen(!accordionOpen)}
                        className="touch-target flex items-center justify-center rounded cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow"
                    >
                        <CaretDownIcon
                            size={14}
                            className={`fill-black transition-transform duration-200 ${accordionOpen ? 'rotate-0' : '-rotate-90'}`}
                        />
                    </button>
                )}
                <Link to={`/agents/${agent._id}`} className="flex-1 flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-light bg-cover bg-center" style={{ backgroundImage: `url(${agent.image || '/images/agent-avatar.jpg'})` }}></div>
                    {agent.name}
                </Link>
                <div className="relative opacity-0 group-hover:opacity-100 group-focus-within:opacity-100">
                    <button
                        type="button"
                        aria-label="Opzioni agente"
                        aria-haspopup="menu"
                        aria-expanded={openDropdown}
                        onClick={() => setOpenDropdown(o => !o)}
                        className="touch-target flex items-center justify-center p-1 rounded cursor-pointer hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow"
                    >
                        <DotsThreeIcon size={20} className='fill-black' weight="bold" />
                    </button>

                    <div role="menu" className="absolute right-0 top-7 rounded-lg shadow-lg w-48 z-[var(--z-dropdown)] bg-white overflow-hidden" style={{ display: openDropdown ? 'block' : 'none' }}>
                        <Link role="menuitem" to={`/agents/${agent._id}/edit`} className="flex items-center gap-2 p-3 hover:bg-verylight focus:outline-none focus-visible:bg-verylight">
                            <PencilIcon size={16} className='fill-black' />
                            Modifica agente
                        </Link>
                        <button type="button" role="menuitem" onClick={removePopupHandler} className="w-full text-left flex items-center gap-2 p-3 hover:bg-verylight focus:outline-none focus-visible:bg-verylight">
                            <TrashIcon size={16} className='fill-black' />
                            Elimina agente
                        </button>
                    </div>
                </div>
            </div>

            {hasChildren && accordionOpen && (
                <div className="pl-4 border-l border-light/50 ml-4">
                    {childAgents.map((childAgent) => (
                        <SidebarAgentItem
                            key={childAgent._id}
                            agent={childAgent}
                            childAgents={[]}
                        />
                    ))}
                </div>
            )}

            <AgentsPopupRemove
                visible={removePopup}
                setVisible={setRemovePopup}
                agent={agent}
            />
        </Fragment>
    )
}